import { render, staticRenderFns } from "./ListagemTipoCotas.vue?vue&type=template&id=24da0f85&"
import script from "./ListagemTipoCotas.vue?vue&type=script&lang=js&"
export * from "./ListagemTipoCotas.vue?vue&type=script&lang=js&"
import style0 from "./ListagemTipoCotas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports